import { QueryClient } from '@tanstack/react-query';

// A module singleton is correct for a client-rendered SPA: there is exactly one
// user per browser tab, so there is no cross-request cache leakage to guard
// against. Route loaders reach it through the router context.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      // Execution status freshness comes from explicit, conditional
      // refetchInterval in feature hooks — never from blanket refetching.
      refetchIntervalInBackground: false,
    },
  },
});
